// @flow
import React from 'react'

require('./styles.scss')

let intro = require('./header.mp4')
let introMobile = require('./header-mobile.mp4')
/*
let introWebM = require('./header.webm')
let introWebMmobile = require('./header.webm')
*/
let poster = require('./cover.jpg')
let posterMobile = require('./cover_mobile.jpg')

export function cover(props: { title: string, subtitle: string }) {
  const isMobile = window.innerWidth < 800
  const isIOS9 = /iPhone OS [6789]_/.test(navigator.userAgent)

  return (
    <div className='cover'>
      {!isIOS9 && (
        <video
          autoPlay
          muted
          playsInline
          preload
          loop
          poster={isMobile ? posterMobile : poster}
          ref={video => {
            if (video) {
              video.setAttribute('playsinline', '')
            }
          }}
        >
          {/* !isMobile && <source src={introWebM} type='video/webm' />*/}
          {/*isMobile && <source src={introWebMmobile} type='video/webm' />*/}
          {/* !isMobile && <source src={intro} type='video/mp4' />*/}
          {isMobile && <source src={introMobile} type='video/mp4' />}
          <source src={intro} type='video/mp4' />
        </video>
      )}
      {isIOS9 && <img src={poster} alt='' className='fallback' />}

      <div className='top gradient' />
      <div className='bottom gradient' />
      <div
        className='ui mobile only'
        style={{
          position: 'absolute',
          bottom: '0',
          left: 0,
          width: '100vw'
        }}
      >
        <div className='ui container'>
          <div className=''>
            <h1
              className='ui inverted left aligned header'
              style={{
                textAlign: 'left'
              }}
            >
              {props.title}
            </h1>
            <div className='sub header'>{props.subtitle}</div>
          </div>
        </div>
      </div>

      <div
        className='mobile hidden'
        style={{
          position: 'absolute',
          bottom: '1em',
          left: 0,
          width: '100vw'
        }}
      >
        <div className='ui left aligned container'>
          <div className=''>
            <h1 className='ui inverted header' style={{}}>
              {props.title}
              <div className='sub header'>{props.subtitle}</div>
            </h1>
          </div>
        </div>
      </div>

      {/*
      <div className='byline'>
        <p className='author'>{props.author}</p>
      </div>
      */}
    </div>
  )
}

export default cover
